export const secondMs = 1000;
export const minuteMs = 60 * secondMs;
export const dayMs = 24 * 60 * minuteMs;

export const toUTCDate = (date: Date, useLocalTime: boolean = true): Date => {
    const year = useLocalTime ? date.getFullYear() : date.getUTCFullYear();
    const month = useLocalTime ? date.getMonth() : date.getUTCMonth();
    const day = useLocalTime ? date.getDate() : date.getUTCDate();

    return new Date(Date.UTC(year, month, day));
};

export const add = (date: Date, milliseconds: number): Date => new Date(date.getTime() + milliseconds);

export const getTimezoneOffsetInMilliseconds = (): number => new Date().getTimezoneOffset() * minuteMs;
